import React, { useState } from "react";
import { Layout, Row, Col, Button,} from "antd";
import PieChart from "../../../../components/Charts/PieChart/PieChart";
import BarChart from "../../../../components/Charts/BarChartContainer";
import Loader from "../../../../components/Loader";
import SideBar from "../../../../components/SideBar/container";

const { Header, Content, Footer } = Layout;

function Analysis(props) {
  const [loadedChart, setLoadedChart] = useState("PieChart");

  return (
    <Layout style={{ height: "100vh" }}>
      <SideBar />
      <Layout>
        <Header
          style={{
            textAlign: "left",
            background: "#fff",
            padding: "0 24px",
            borderBottom: "1px solid"
          }}
        >
          <h1 style={{ float: "left" }}>Surveys</h1>
          <Button
            type="primary"
            disabled={!Object.keys(props.drivers).length}
            onClick={() => {
              loadedChart === "PieChart"
                ? setLoadedChart("Driver")
                : setLoadedChart("PieChart");
            }}
            style={{ float: "right", marginTop: 10 }}
          >
            {loadedChart === "PieChart"
              ? "Gå til Drivers"
              : "Gå til Transactional Analysis"}
          </Button>
        </Header>
        <Content style={{ backgroundColor: "rgb(0, 21, 41)" }}>
          <div
            style={{
              padding: "40px 24px",
              background: "#rgb(0, 21, 41)",
              minHeight: 360
            }}
          >
            <Row
              className="survey_content_container survey_results_container admin_results"
              style={{ color: "#fff" }}
            >
              <Row>
                <Row gutter={16}>
                  <Col>
                    {props.loading ? (
                      <Loader invert />
                    ) : (
                      [
                        loadedChart === "PieChart" ? (
                          <div>
                            <PieChart
                              numberCells={2}
                              labels={["CP", "NP"]}
                              data={props.result}
                              language={props.language}
                            />
                            <PieChart
                              numberCells={1}
                              labels={["A"]}
                              data={props.result}
                              language={props.language}
                            />
                            <PieChart
                              numberCells={3}
                              labels={["AC", "WC", "NC"]}
                              data={props.result}
                              language={props.language}
                            />
                          </div>
                        ) : (
                          <BarChart drivers={props.drivers} />
                        )
                      ]
                    )}
                  </Col>
                </Row>
              </Row>
            </Row>
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>iLead © 2018</Footer>
      </Layout>
    </Layout>
  );
}

export default Analysis;

Analysis.defaultProps = {
  data: []
};



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultDocument/ResultTADocument/Analysis.js